enum WebsocketRequestType {
    UpdateNotificationUpdateSubscription = 'UpdateNotificationUpdateSubscription',
    UpdateReservationUpdateSubscription = 'UpdateReservationUpdateSubscription',
    UpdateResourceUpdateSubscription = 'UpdateResourceUpdateSubscription',
}

export default WebsocketRequestType;
